// List of currently recognized tags
export enum Tag {
    alternative = "Alternative",
    ambient = "Ambient",
    bluegrass = "Bluegrass",
    country = "Country",
    disco = "Disco",
    edm = "EDM",
    electro = "Electro",
    emo = "Emo",
    folk = "Folk",
    grunge = "Grunge",
    hardcore = "Hardcore",
    house = "House",
    indie = "Indie",
    jazz = "Jazz",
    jungle = "Jungle",
    metal = "Metal",
    pop = "Pop",
    psychedelic = "Psychedelic",
    punk = "Punk",
    rap = "Rap",
    reggae = "Reggae",
    rock = "Rock",
    shoegaze = "Shoegaze",
    techno = "Techno",
    blues = "Blues",
    classical = "Classical",
    death_metal = "Death Metal",
    heavy_metal = "Heavy Metal",
    hip_hop = "Hip Hop",
    new_wave = "New Wave",
    r_b = "R&B",
    soul = "Soul"
}